import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '../store';
import { SubscriptionType } from '@Helper/Interfaces';

export interface IProps {
  pricingType: SubscriptionType;
  trialEndDate: string;
  showTrialEndModal: boolean;
}

const initialState: IProps = {
  pricingType: SubscriptionType.TRIAL,
  trialEndDate: '',
  showTrialEndModal: false,
};

export const pricingSlice = createSlice({
  name: 'pricingAssets',
  initialState,
  reducers: {
    postPricingType: (state, action: PayloadAction<SubscriptionType>) => {
      state.pricingType = action.payload;
    },
    postPricingTrialEndDate: (state, action: PayloadAction<string>) => {
      state.trialEndDate = action.payload;
    },
    postShowTrialEndModal: (state, action: PayloadAction<boolean>) => {
      state.showTrialEndModal = action.payload;
    },
  },
});

export const { postPricingType } = pricingSlice.actions;
export const { postPricingTrialEndDate } = pricingSlice.actions;
export const { postShowTrialEndModal } = pricingSlice.actions;

export const getPricingType = (state: RootState) => state.pricingReducer;
export const getShowTrialEndModal = (state: RootState) =>
  state.pricingReducer.showTrialEndModal;

export default pricingSlice.reducer;
